<div mat-dialog-content>
  <h2>IMEI</h2>
  <p class="imei-top-text">Hva er det og hvor finner du det</p>

  <div class="imei-image-container">
    <img alt="How to find IMEI" class="image" [src]="imageAssets.imei" />
  </div>

  <p class="imei-info-text">
    International Mobile Equipment Identity (IMEI) brukes til å identifisere selve mobiltelefonen.
  </p>

  <p class="imei-header-text">Hvorfor trenger vi IMEI:</p>
  <ul class="imei-info-text">
    <li>For å unngå svindelsaker.</li>
    <li>For at kundeservice lettere kan bistå kunden ved mobilhenvendelser.</li>
    <li>For å kunne identifisere den faktiske telefonen kunden kjøper.</li>
  </ul>

  <p class="imei-header-text">Hvor finner du IMEI:</p>
  <p class="imei-info-text">
    IMEI-nummeret finner man som regel på baksiden av forpakningen på venstre side, eller på den korte undersiden, se bildet
    over.
  </p>
</div>

<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button
      color="outlined"
      tabindex="0"
      testId="close-imei-info-dialog-button"
      (click)="dialogRef.close()"
      (keydown.enter)="dialogRef.close()"
    >
      Ok, lukk
    </app-ice-button>
  </div>
</div>
